import { DataSecurityMonitorType } from '@sonar-software/sonar-core';
import React from 'react';
import { SETTINGS_DATA_SECURITY_COPY } from '@sonar-software/sonar-ts-constants';
import { Tag } from 'antd';
const monitorTypeColors = {
    [DataSecurityMonitorType.NewObjectAndFieldAccess]: 'cyan',
    [DataSecurityMonitorType.NewUser]: 'green',
    [DataSecurityMonitorType.Uptime]: 'magenta',
    [DataSecurityMonitorType.Personal]: 'blue',
    [DataSecurityMonitorType.SetupAuditTrail]: 'orange'
};
export const monitorTypeLabel = {
    [DataSecurityMonitorType.NewObjectAndFieldAccess]: SETTINGS_DATA_SECURITY_COPY.OBJECT_AND_FIELD_ACCESS,
    [DataSecurityMonitorType.NewUser]: SETTINGS_DATA_SECURITY_COPY.NEW_USER,
    [DataSecurityMonitorType.Uptime]: SETTINGS_DATA_SECURITY_COPY.UPTIME,
    [DataSecurityMonitorType.Personal]: SETTINGS_DATA_SECURITY_COPY.PERSONAL,
    [DataSecurityMonitorType.SetupAuditTrail]: SETTINGS_DATA_SECURITY_COPY.SETUP_AUDIT_TRAIL
};
export const monitorParentType = {
    [DataSecurityMonitorType.NewApp]: DataSecurityMonitorType.Personal,
    [DataSecurityMonitorType.Following]: DataSecurityMonitorType.Personal,
    [DataSecurityMonitorType.TimelineSummary]: DataSecurityMonitorType.Personal,
    [DataSecurityMonitorType.NewObjectAndFieldAccess]: DataSecurityMonitorType.NewObjectAndFieldAccess,
    [DataSecurityMonitorType.ConfigurableFieldAccess]: DataSecurityMonitorType.NewObjectAndFieldAccess
};
export const MonitorTypeTag = ({ monitorTypeId }) => {
    var _a;
    if (!Number.isInteger(monitorTypeId)) {
        return null;
    }
    const id = (_a = monitorParentType[monitorTypeId]) !== null && _a !== void 0 ? _a : monitorTypeId;
    const label = monitorTypeLabel[id];
    const color = monitorTypeColors[id];
    return React.createElement(Tag, { color: color }, label);
};
